<!-- メイン -->
<div class="main" *ngIf="isDataLoaded">
  <!-- メインコンテンツ -->
  <div class="main-content">
    <!-- 戻る -->
    <div class="return">
      <button pButton type="button" label="一覧へ戻る" icon="pi pi-angle-left" class="p-button-text"
        (click)="moveC231()"></button>
    </div>
    <div class="p-fluid p-formgrid p-grid screen-support">
      <div class="p-col-9 content">
        <div class="p-fluid p-formgrid p-grid support-header">
          <div class="p-col-12">
            <p-card class="support-header-card">
              <div class="support-header-card-show">
                <div class="p-fluid p-formgrid p-grid support-header-card-detail">
                  <div class="p-col-2 image">
                    <div class="support-header-card-detail-img" [ngStyle]="{
                        'background-image':
                          'url(' + detailTask?.icon_image + ')'
                      }"></div>
                  </div>
                  <div class="p-col-10 support-desc">
                    <div class="support-description-detail">
                      <span class="support-tag-category" [ngClass]="setClassSubId()">{{ detailTask?.class_sub_id }}</span>
                      <span class="support-large-title primary-title p-text-bold"  pTooltip="{{ detailTask?.municipalities + ' ' + detailTask?.organization_name }}">
                        {{ detailTask?.municipalities + ' ' + detailTask?.organization_name }}
                      </span>
                      <!-- Change location -->
                      <div class="support-sub-title">
                        <span pTooltip="{{ detailTask?.oneword_message }}">{{ detailTask?.oneword_message }}</span>
                      </div>
                    </div>
                    <!-- <div class="support-btn" *ngIf="detailTask?.isOwner === 1">
                      <ng-container>
                        <div class="p-col-12">
                          <div class="func-with-owner">
                            <div class="p-fluid p-formgrid p-grid btn-control">
                              <div *ngIf="detailTask?.access_modifiers == 1" class="center not-public">
                                <i class="pi pi-lock"></i>
                                <span>非公開</span>
                              </div>

                              <div class="center public" *ngIf="
                                  detailTask?.access_modifiers == 0;
                                ">
                                <span>公開中</span>
                              </div>

                              <div class="func-btn" *ngIf="class_id !== '9' && class_id">
                                <button pButton pRipple type="button" label="編集する" class="p-button-raised btn-edit"
                                  (click)="moveM301()"></button>
                                <button pButton pRipple type="button" label="削除する"
                                  class="p-button-raised bg-white-color btn-delete"
                                  (click)="deleteAgendaSoltionById()"></button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </div> -->
                  </div>
                </div>
              </div>
            </p-card>
          </div>


          <div class="p-col-12">
            <span class="p-text-bold">団体情報</span>
          </div>
          <div class="p-col-12">
            <div class="support-separate"></div>
          </div>

          <div class="p-col-12">
            <div class="support-table-detail">
              <div class="support-line-first">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 large-title">
                    <span class="title-overview">団体区分詳細</span>
                  </div>
                  <div class="p-col-9 description-title-overview">
                    <span>
                      {{ detailTask?.class_sub_id }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-col-12">
            <hr class="sperate-between-line" />
          </div>

          <div class="p-col-12">
            <div class="support-table-detail">
              <div class="support-line-third">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 large-title">
                    <span class="title-overview">団体名</span>
                  </div>
                  <div class="p-col-9 description-title-overview">
                    <span>
                      {{ detailTask?.organization_name }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-col-12">
            <hr class="sperate-between-line" />
          </div>

          <div class="p-col-12">
            <div class="support-table-detail">
              <div class="support-line-second">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 large-title">
                    <span class="title-overview no-wrap">所在地(市区町村)
                    </span>
                  </div>
                  <div class="p-col-9 description-title-overview">
                    <span>
                      {{ detailTask?.municipalities }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-col-12">
            <hr class="sperate-between-line" />
          </div>

          <div class="p-col-12">
            <div class="support-table-detail">
              <div class="support-line-fourth">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 large-title">
                    <span class="title-overview no-wrap">所在地<br>&nbsp;(それ以降の住所)</span>
                  </div>
                  <div class="p-col-9 description-title-overview">
                    <span>
                      {{ detailTask?.address_building }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-col-12">
            <hr class="sperate-between-line" />
          </div>

          <div class="p-col-12">
            <div class="support-table-detail">
              <div class="support-line-sixth">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 large-title">
                    <span class="title-overview">電話番号</span>
                  </div>
                  <div class="p-col-9 description-title-overview">
                    <span>
                      {{ detailTask?.tel }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="p-col-12">
            <div class="support-table-detail">
              <div class="support-line-sixth">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 large-title">
                    <span class="title-sub">※各団体へのお問い合わせは、<br>急ぎの場合を除き、原則、本<br>システム内のチャットでお願<br>いします。</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-col-12">
            <div class="sperate-header"></div>
          </div>

          <div class="p-col-12">
            <span class="p-text-bold seperate">希望内容</span>
          </div>

          <div class="p-col-12">
            <div class="support-separate"></div>
          </div>

          <div class="p-col-12">
            <div class="support-table-detail">
              <div class="support-line-third">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 large-title">
                    <span class="title-overview">実施教科等</span>
                  </div>
                  <div class="p-col-9 description-title-overview">
                    <span>
                      {{ detailTask?.desired_subject }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-col-12">
            <div class="support-table-detail">
              <div class="support-line-sixth">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 large-title">
                    <span class="title-sub">&nbsp;（学校における活動の位置づけ）</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-col-12">
            <hr class="sperate-between-line" />
          </div>

          <div class="p-col-12">
            <div class="support-table-detail">
              <div class="support-line-third">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 large-title">
                    <span class="title-overview">参加生徒の学年</span>
                  </div>
                  <div class="p-col-9 description-title-overview">
                    <span>
                      {{ detailTask?.target_grade }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-col-12">
            <hr class="sperate-between-line" />
          </div>

          <div class="p-col-12">
            <div class="support-table-detail">
              <div class="support-line-third">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 large-title">
                    <span class="title-overview">参加生徒人数</span>
                  </div>
                  <div class="p-col-9 description-title-overview">
                    <span>
                      {{ detailTask?.desired_people_number }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-col-12">
            <hr class="sperate-between-line" />
          </div>

          <div class="p-col-12">
            <div class="support-table-detail">
              <div class="support-line-third">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 large-title">
                    <span class="title-overview">希望時期・日数</span>
                  </div>
                  <div class="p-col-9 description-title-overview">
                    <span>
                      {{ detailTask?.desired_datetime }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-col-12">
            <hr class="sperate-between-line" />
          </div>

          <div class="p-col-12">
            <div class="support-table-detail">
              <div class="support-line-third">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 large-title">
                    <span class="title-overview">実施場所</span>
                  </div>
                  <div class="p-col-9 description-title-overview">
                    <span>
                      {{ detailTask?.desired_location }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-col-12">
            <hr class="sperate-between-line" />
          </div>

          <div class="p-col-12">
            <div class="support-table-detail">
              <div class="support-line-third">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 large-title">
                    <span class="title-overview">実施可能曜日</span>
                  </div>
                  <div class="p-col-9 description-title-overview">
                    <span>
                      {{ detailTask?.desired_dayweek }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-col-12">
            <hr class="sperate-between-line" />
          </div>

          <div class="p-col-12">
            <div class="support-table-detail">
              <div class="support-line-third">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 large-title">
                    <span class="title-overview">実施希望時間</span>
                  </div>
                  <div class="p-col-9 description-title-overview">
                    <span>
                      {{ detailTask?.desired_time }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-col-12">
            <hr class="sperate-between-line" />
          </div>

          <div class="p-col-12">
            <div class="support-table-detail">
              <div class="support-line-third">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 large-title">
                    <span class="title-overview">希望の詳細</span>
                  </div>
                  <div class="p-col-9 description-title-overview">
                    <span>
                      {{ detailTask?.desired_content }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-col-12">
            <hr class="sperate-between-line" />
          </div>

          <div class="p-col-12">
            <div class="support-table-detail">
              <div class="support-line-third">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 large-title">
                    <span class="title-overview">その他、補足事項</span>
                  </div>
                  <div class="p-col-9 description-title-overview">
                    <span>
                      {{ detailTask?.remark }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-col-12">
            <hr class="sperate-between-line" />
          </div>

          <div class="p-col-12">
            <div class="support-table-detail">
              <div class="support-line-third">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-col-3 large-title">
                    <span class="title-overview">担当者氏名</span>
                  </div>
                  <div class="p-col-9 description-title-overview">
                    <span>
                      {{ detailTask?.manager_name }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-col-12">
            <hr class="sperate-between-line" />
          </div>

          <div class="p-col-12">
            <ng-container *ngIf="class_id === '2' && class_id">
              <div class="p-d-flex p-jc-center">
                <div class="p-col-3 btn-review">
                  <button pButton type="button" label="マッチング依頼を登録" (click)="movec401()"></button>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-pub-evaluation-dialog *ngIf="isShowDialogEvaluate" (returnStatusDialog)="closeDialogEvaluation($event)"
  [matchId]="matchId"></app-pub-evaluation-dialog>
<!-- 登録画面[入力項目生成(アイテムアダプター)]-->
<app-generate-input (reloadID)="searchReplacement($event)"></app-generate-input>

<!-- 削除ダイアログ-->
<app-delete-dialog (reloadID)="redirectToList($event)"></app-delete-dialog>

<!-- Toastメッセージ表示 -->
<p-toast position="top-center"></p-toast>